<template>
  <div class="brand">
    <el-row style="margin-left: -5px; margin-right: -5px" class="select">
      <el-col :span="12" style="padding-left: 5px; padding-right: 5px">
        <div class="picker">
          <el-popover
            class="fact"
            placement="bottom"
            :width="width"
            trigger="click"
            ref="popoverfact"
            @hide="fhidden"
            popper-class="search-popper"
            @show="fshow"
          >
            <!-- 内容 -->
            <transition name="el-zoom-in-top">
              <div class="confactleft" v-show="pin">
                <el-input
                  ref="finput"
                  v-model="filterTextf"
                  :clearable="true"
                  v-on:input="searchfact"
                ></el-input>
                <div class="scrollbar">
                  <!-- 常用 -->
                  <div class="chang" v-if="filterTextf == ''">
                    <div v-for="(item, i) in chang" :key="i">
                      <div class="chang-t">{{ item.s }}</div>
                      <div
                        class="chang-c"
                        v-for="(data, j) in item.dc"
                        :key="j"
                        @click="facthandel(data)"
                        :title="data.factName"
                      >
                        <img
                          :src="data.factImg"
                          alt=""
                          style="width: 40px; height: 30px; margin-right: 16px"
                        />
                        <span>{{ data.factName }}</span>
                      </div>
                    </div>
                  </div>
                  <!-- 分组 -->
                  <div class="data" v-if="filterTextf == ''">
                    <div v-for="(optitem, k) in fdata" :key="k">
                      <div class="data-t">{{ optitem.s }}</div>
                      <div
                        class="data-c"
                        :class="{ factactive: factid == optdata.factID }"
                        v-for="(optdata, z) in optitem.d"
                        :key="z"
                        :title="optdata.factName"
                        @click="facthandel(optdata)"
                      >
                        <span>{{ optdata.factName }}</span>
                      </div>
                    </div>
                  </div>
                  <!-- 搜索返回数据 -->
                  <div class="search" v-if="filterTextf != ''">
                    <div
                      v-for="(item, k) in searchfactdata"
                      :key="k"
                      @click="facthandel(item)"
                    >
                      <div class="search-t">{{ item.factName }}</div>
                    </div>
                    <div class="search-t" v-if="searchfactdata.length == 0">
                      暂未查询到相关数据
                    </div>
                  </div>
                </div>
              </div>
            </transition>
            <!-- 框 -->
            <div
              slot="reference"
              class="factinput"
              @click="pinicon"
              ref="pinwidth"
            >
              <span class="pinpai">品牌</span>
              <span class="pinnane">
                <span v-html="factvalue">{{ factvalue }}</span>
              </span>
              <span class="icon" :class="{ visible: pin }"
                ><i class="el-icon-arrow-down"></i
              ></span>
            </div>
          </el-popover>
        </div>
      </el-col>
      <el-col :span="12" style="padding-left: 5px; padding-right: 5px">
        <div class="picker">
          <el-popover
            class="fact"
            placement="bottom"
            :width="width"
            trigger="click"
            ref="popoverser"
            @hide="shidden"
            popper-class="search-popper"
            @show="sshow"
          >
            <transition name="el-zoom-in-top">
              <div class="confact" v-show="xi">
                <div class="useleft">
                  <el-input
                    ref="sinput"
                    v-model="filterTexts"
                    :clearable="true"
                  ></el-input>
                  <div class="scrollbar">
                    <!-- <el-scrollbar style="height:100%"> -->
                    <el-tree
                      :data="sdata"
                      :props="serd"
                      ref="stree"
                      :filter-node-method="filterser"
                      @node-click="serhandle"
                      :highlight-current="true"
                      node-key="SeriesId"
                      :current-node-key="defaultnode"
                      :default-expanded-keys="defnode"
                    >
                      <span
                        class="custom-tree-node"
                        :title="data.SeriesName"
                        slot-scope="{ node, data }"
                      >
                        <span :title="data.SeriesName">{{
                          data.SeriesName
                        }}</span>
                      </span>
                    </el-tree>
                    <!-- </el-scrollbar> -->
                  </div>
                </div>
                <!--  <div class="use" v-show="xi">
                  <span style="color: red">您最近的浏览记录</span
                  ><span style="cursor: pointer" @click="delectuse">清除</span>
                  <div v-for="item in usearr" :key="item.sid">
                    <span
                      style="cursor: pointer"
                      @click="changsid(item.data)"
                      >{{ item.sname }}</span
                    >
                  </div>
                </div>
                -->
              </div>
            </transition>

            <div
              slot="reference"
              class="factinput"
              @click="xiicon"
              ref="xiwidth"
            >
              <span class="pinpai">系列</span>
              <span class="pinnane"
                ><span>{{ servalue }}</span></span
              >
              <span class="icon" :class="{ visible: xi }"
                ><i class="el-icon-arrow-down"></i
              ></span>
            </div>
          </el-popover>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { brand, series } from "../network/home";

import { mapState } from "vuex";

export default {
  data() {
    return {
      usearr: [], //存贮浏览过的系类
      userwer: [],
      width: "" /* 弹出框的宽度变化 */,
      pin: false /* 品牌框小图标 */,
      xi: false /* 系列框小图标 */,
      filterTextf: "" /* 品牌搜索框返回的数据 */,
      filterTexts: "" /* 系列搜索框返回的数据 */,

      factres: [] /* 品牌所有数据 */,
      factvalue: "" /* 默认品牌名 */,
      s: [
        "常用",
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z",
      ],
      chang: [] /* 常用品牌数据 */,
      fdata: [] /* 品牌数据 */,
      searchfactdata: [] /* 搜索品牌返回数据 */,
      factid: "",

      sdata: [] /* 系列总数据 */,
      defnode: [] /* 默认展开节点id */,
      defaultnode: "" /* 当前默认选中节点 */,
      defserdata: [] /* 默认选中系列数据 */,
      servalue: "" /* 默认系列名 */,
      serd: {
        /* 树节点模板 */
        children: "child",
        label: "SeriesName",
      },

      searchserdata: [] /* 搜索系列返回的数据 */,
    };
  },

  created() {
    this.factdata();
    this.usearr = JSON.parse(this.getCookie("userarr"));
    this.userwer = JSON.parse(this.getCookie("userwer"));
    console.log(1223);
  },

  watch: {
    /* 筛选系列 */
    filterTexts(val) {
      this.$refs.stree.filter(val);
    },
    /* 监听品牌id的变化 */
    fid(newVal) {
      this.fact(newVal);
    },
    /* 监听系列id的变化 */
    sid(newVal) {
      this.sert(this.fid, newVal);
    },
  },

  computed: {
    ...mapState(["fid", "sid", "fname"]),
  },

  methods: {
    changsid(data) {
      this.$refs.popoverser.showPopper = false; //隐藏系列弹出框
      this.servalue = data.SeriesName;
      this.$store.commit("sid", data.SeriesId); /* 把系列 id存入vuex */

      this.$store.commit("shortname", data.ShortName); /* 把系列 简称存入vuex */
      // console.log(data);

      let index = data.SeriesName.lastIndexOf(" ");
      let s = data.SeriesName.substring(index + 1, data.SeriesName.length);
      this.$store.commit("s", s); /* 把品类名存入vuex */
      this.$store.commit(
        "dusname",
        data.SeriesName.substring(index + 1, data.SeriesName.length)
      ); /* 把品类名存入vuex */
      let def = [];
      def = data.defaultSelected.split("-").map((x) => parseInt(x));
      this.$store.commit("defaultselect", def);
    },
    /* 品牌框小图标的切换变化 */
    pinicon() {
      this.pin = !this.pin;
      this.width = this.$refs.pinwidth.clientWidth;
    },
    /* 系列框小图标切换变化 */
    xiicon() {
      this.xi = !this.xi;
      this.width = this.$refs.xiwidth.clientWidth;
    },
    /* 弹框隐藏事件 */
    fhidden() {
      this.pin = false;
    },
    shidden() {
      this.xi = false;
    },
    /* 弹框显示事件 */
    fshow() {
      /* 使搜索框聚焦 */
      this.$nextTick(function () {
        this.$refs.finput.focus();
      });
      this.filterTextf = "";
    },
    sshow() {
      this.$nextTick(function () {
        this.$refs.sinput.focus();
      });
      this.filterTexts = "";
    },
    /* 筛选系列数据 */
    filterser(value, data) {
      if (!value) return true;
      return (
        data.SeriesName.toLowerCase().indexOf(
          value.replace(/\s*/g, "").toLowerCase()
        ) !== -1
      );
    },

    /* 获取数据 */
    /* 1、获取厂商数据 */
    factdata() {
      brand().then((res) => {
        // console.log(res);
        this.$store.commit("factdata", res); /* 把品牌产厂商存入vuex */
        // console.log(res[0].factID);
        this.factres = res;
        for (let i = 0; i < this.s.length; i++) {
          let f = [],
            c = [];
          for (let j = 0; j < res.length; j++) {
            if (i == 0) {
              if (res[j].IsComm == "Y") {
                c.push(res[j]);
                // console.log(1);
              }
            } else {
              if (this.s[i] == res[j].k) {
                f.push(res[j]);
                // console.log(2);
              }
            }
          }
          /* 分组 */
          if (f.length != 0) {
            this.fdata.push({
              s: this.s[i],
              d: f,
            });
          }
          /* 常用 */
          if (c.length != 0) {
            this.chang.push({
              s: this.s[i],
              dc: c,
            });
          }
        }
        this.facthandel(res[0]);
      });
    },
    delectuse() {
      this.userwer = [];
      this.usearr = [];
      var exdate = new Date();
      exdate.setDate(exdate.getDate() + 30);
      document.cookie =
        "userarr" +
        "=" +
        decodeURIComponent("") +
        ";expires=" +
        exdate.toGMTString();
      document.cookie =
        "userwer" +
        "=" +
        decodeURIComponent("") +
        ";expires=" +
        exdate.toGMTString();
    },
    /* 1.1搜索品牌 */
    searchfact() {
      let searchdata = [];
      if (this.filterTextf != "") {
        for (let i = 0; i < this.factres.length; i++) {
          if (
            this.factres[i].factName
              .toLowerCase()
              .indexOf(this.filterTextf.toLowerCase()) !== -1
          ) {
            searchdata.push(this.factres[i]);
          }
        }
      }
      this.searchfactdata = searchdata;
    },

    /* 2、根据品牌id请求系列数据 */
    facthandel(data) {
      // console.log(data);
      this.factid = data.factID; /* 点击获取品牌id */
      this.$store.commit("fid", data.factID); /* 把品牌 id存入vuex */
      this.$store.commit("sid", data.SeriesId); /* 把系列 id存入vuex */
      this.$store.commit("fname", data.factName); /* 把系列 id存入vuex */
      this.$store.commit(
        "fsortname",
        data.factSortName
      ); /* 把系列 id存入vuex */

      this.factvalue = data.factName;

      this.$refs.popoverfact.showPopper = false; //隐藏品牌弹出框
      series(data.factID).then((res) => {
        /* 请求系列接口 */
        this.sdata = res;
        // console.log(res);
        this.defnode = [];
        for (let i = 0; i < res.length; i++) {
          for (let j = 0; j < res[i].child.length; j++) {
            /* 判断两层还是三层 */
            if (res[i].child[j].child.length != 0) {
              for (let z = 0; z < res[i].child[j].child.length; z++) {
                if (res[i].child[j].child[z].SeriesId == data.SeriesId) {
                  this.servalue =
                    res[i].child[j].child[z].SeriesName; /* 默认系列框名 */
                  this.defnode.push(
                    res[i].SeriesId,
                    res[i].child[j].SeriesId
                  ); /* 默认展开的节点 */

                  this.defaultnode =
                    res[i].child[j].child[z].SeriesId; /* 默认展开高亮的节点 */
                  this.$nextTick(function () {
                    this.$refs.stree.setCurrentKey(
                      this.defaultnode
                    ); /* 使默认的节点高亮 */
                  });
                  this.$store.commit(
                    "sid",
                    res[i].child[j].child[z].SeriesId
                  ); /* 把系列 id存入vuex */
                  this.$store.commit(
                    "shortname",
                    res[i].child[j].child[z].ShortName
                  ); /* 把系列 简称存入vuex */
                  let index =
                    res[i].child[j].child[z].SeriesName.lastIndexOf(" ");
                  let s = res[i].child[j].child[z].SeriesName.substring(
                    index + 1,
                    res[i].child[j].child[z].SeriesName.length
                  );
                  // console.log(index);
                  // console.log(s);
                  this.$store.commit("s", s); /* 把品类名存入vuex */
                  this.$store.commit(
                    "dusname",
                    res[i].child[j].child[z].SeriesName.substring(
                      index + 1,
                      res[i].child[j].child[z].SeriesName.length
                    )
                  ); /* 把品类名存入vuex */
                  let def = [];
                  def = res[i].child[j].child[z].defaultSelected
                    .split("-")
                    .map((x) => parseInt(x));
                  this.$store.commit(
                    "defaultselect",
                    def
                  ); /* 把品类名存入vuex */
                }
              }
            } else {
              if (res[i].child[j].SeriesId == data.SeriesId) {
                this.servalue = res[i].child[j].SeriesName;
                this.defnode.push(res[i].SeriesId);
                this.defaultnode = res[i].child[j].SeriesId;
                this.$nextTick(function () {
                  this.$refs.stree.setCurrentKey(this.defaultnode);
                });
                this.$store.commit(
                  "sid",
                  res[i].child[j].SeriesId
                ); /* 把系列 id存入vuex */
                this.$store.commit(
                  "shortname",
                  res[i].child[j].ShortName
                ); /* 把系列 简称存入vuex */
                let index = res[i].child[j].SeriesName.lastIndexOf(" ");

                let s = res[i].child[j].SeriesName.substring(
                  index + 1,
                  res[i].child[j].SeriesName.length
                );
                this.$store.commit("s", s); /* 把品类名存入vuex */
                // console.log(s);
                this.$store.commit(
                  "dusname",
                  res[i].child[j].SeriesName.substring(
                    index + 1,
                    res[i].child[j].SeriesName.length
                  )
                ); /* 把品类名存入vuex */
                let def = [];
                def = res[i].child[j].defaultSelected
                  .split("-")
                  .map((x) => parseInt(x));
                this.$store.commit("defaultselect", def); /* 把品类名存入vuex */
              }
            }
          }
        }
      });
    },

    /* 3、总搜索后品牌变化时 */
    fact(newfid) {
      this.factid = newfid;
      this.factvalue = this.fname;
      series(newfid).then((res) => {
        this.sdata = res;
        this.defnode = [];
        for (let i = 0; i < res.length; i++) {
          for (let j = 0; j < res[i].child.length; j++) {
            /* 判断两层还是三层 */
            if (res[i].child[j].child.length != 0) {
              for (let z = 0; z < res[i].child[j].child.length; z++) {
                if (res[i].child[j].child[z].SeriesId == this.sid) {
                  this.servalue =
                    res[i].child[j].child[z].SeriesName; /* 默认系列框 */
                  this.defnode.push(res[i].SeriesId, res[i].child[j].SeriesId);
                  this.defaultnode = res[i].child[j].child[z].SeriesId;
                  this.$nextTick(function () {
                    this.$refs.stree.setCurrentKey(this.defaultnode);
                  });
                  this.$store.commit(
                    "shortname",
                    res[i].child[j].child[z].ShortName
                  ); /* 把系列 简称存入vuex */
                  let index =
                    res[i].child[j].child[z].SeriesName.lastIndexOf(" ");
                  let s = res[i].child[j].child[z].SeriesName.substring(
                    index + 1,
                    res[i].child[j].child[z].SeriesName.length
                  );
                  this.$store.commit("s", s); /* 把品类名存入vuex */
                  // console.log(s);
                  // let i=res[i].child[j].child[z].SeriesName.lastIndexOf(' ')
                  this.$store.commit(
                    "dusname",
                    res[i].child[j].child[z].SeriesName.substring(
                      index + 1,
                      res[i].child[j].child[z].SeriesName.length
                    )
                  ); /* 把品类名存入vuex */
                  let def = [];
                  def = res[i].child[j].child[z].defaultSelected
                    .split("-")
                    .map((x) => parseInt(x));
                  this.$store.commit(
                    "defaultselect",
                    def
                  ); /* 把品类名存入vuex */
                }
              }
            } else {
              if (res[i].child[j].SeriesId == this.sid) {
                this.servalue = res[i].child[j].SeriesName;
                this.defnode.push(res[i].SeriesId);
                this.defaultnode = res[i].child[j].SeriesId;
                this.$nextTick(function () {
                  this.$refs.stree.setCurrentKey(this.defaultnode);
                });
                this.$store.commit(
                  "shortname",
                  res[i].child[j].ShortName
                ); /* 把系列 简称存入vuex */
                let index = res[i].child[j].SeriesName.lastIndexOf(" ");
                let s = res[i].child[j].SeriesName.substring(
                  index + 1,
                  res[i].child[j].SeriesName.length
                );
                this.$store.commit("s", s); /* 把品类名存入vuex */
                // console.log(s);
                this.$store.commit(
                  "dusname",
                  res[i].child[j].SeriesName.substring(
                    index + 1,
                    res[i].child[j].SeriesName.length
                  )
                ); /* 把品类名存入vuex */
                let def = [];
                def = res[i].child[j].defaultSelected
                  .split("-")
                  .map((x) => parseInt(x));
                this.$store.commit("defaultselect", def); /* 把品类名存入vuex */
              }
            }
          }
        }
      });
    },

    /* 3.1、总搜索后系列变化时 */
    sert(newfid, newsid) {
      series(newfid).then((res) => {
        this.factid = newfid;
        this.factvalue = this.fname;
        this.sdata = res;
        this.defnode = [];
        for (let i = 0; i < res.length; i++) {
          for (let j = 0; j < res[i].child.length; j++) {
            /* 判断两层还是三层 */
            if (res[i].child[j].child.length != 0) {
              for (let z = 0; z < res[i].child[j].child.length; z++) {
                if (res[i].child[j].child[z].SeriesId == newsid) {
                  this.servalue =
                    res[i].child[j].child[z].SeriesName; /* 默认系列框 */
                  this.defnode.push(res[i].SeriesId, res[i].child[j].SeriesId);

                  this.defaultnode = res[i].child[j].child[z].SeriesId;
                  this.$nextTick(function () {
                    this.$refs.stree.setCurrentKey(this.defaultnode);
                  });
                  this.$store.commit(
                    "shortname",
                    res[i].child[j].child[z].ShortName
                  ); /* 把系列 简称存入vuex */
                  let index =
                    res[i].child[j].child[z].SeriesName.lastIndexOf(" ");
                  let s = res[i].child[j].child[z].SeriesName.substring(
                    index + 1,
                    res[i].child[j].child[z].SeriesName.length
                  );
                  this.$store.commit("s", s); /* 把品类名存入vuex */
                  // console.log(s);
                  this.$store.commit(
                    "dusname",
                    res[i].child[j].child[z].SeriesName.substring(
                      index + 1,
                      res[i].child[j].child[z].SeriesName.length
                    )
                  ); /* 把品类名存入vuex */
                  let def = [];
                  def = res[i].child[j].child[z].defaultSelected
                    .split("-")
                    .map((x) => parseInt(x));
                  this.$store.commit(
                    "defaultselect",
                    def
                  ); /* 把品类名存入vuex */
                }
              }
            } else {
              if (res[i].child[j].SeriesId == newsid) {
                this.servalue = res[i].child[j].SeriesName;
                this.defnode.push(res[i].SeriesId);
                this.defaultnode = res[i].child[j].SeriesId;
                this.$nextTick(function () {
                  this.$refs.stree.setCurrentKey(this.defaultnode);
                });
                // console.log(this.defnode);
                this.$store.commit(
                  "shortname",
                  res[i].child[j].ShortName
                ); /* 把系列 简称存入vuex */
                let index = res[i].child[j].SeriesName.lastIndexOf(" ");
                let s = res[i].child[j].SeriesName.substring(
                  index + 1,
                  res[i].child[j].SeriesName.length
                );
                this.$store.commit("s", s); /* 把品类名存入vuex */
                // console.log(s);
                this.$store.commit(
                  "dusname",
                  res[i].child[j].SeriesName.substring(
                    index + 1,
                    res[i].child[j].SeriesName.length
                  )
                ); /* 把品类名存入vuex */
                let def = [];
                def = res[i].child[j].defaultSelected
                  .split("-")
                  .map((x) => parseInt(x));
                this.$store.commit("defaultselect", def); /* 把品类名存入vuex */
              }
            }
          }
        }
      });
    },
    getCookie(key) {
      if (document.cookie.length > 0) {
        var start = document.cookie.indexOf(key + "=");
        if (start !== -1) {
          start = start + key.length + 1;
          var end = document.cookie.indexOf(";", start);
          if (end === -1) end = document.cookie.length;
          return unescape(document.cookie.substring(start, end));
        }
      }
      return "";
    },

    serhandle(data, node) {
      // console.log(data);
      if (node.childNodes.length == 0) {
        /* 操作node节点 */
        if (data.defaultSelected != "") {
          this.$refs.popoverser.showPopper = false; //隐藏系列弹出框
          this.servalue = data.SeriesName;
          this.$store.commit("sid", data.SeriesId); /* 把系列 id存入vuex */

          this.$store.commit(
            "shortname",
            data.ShortName
          ); /* 把系列 简称存入vuex */
          // console.log(data);

          let index = data.SeriesName.lastIndexOf(" ");
          let s = data.SeriesName.substring(index + 1, data.SeriesName.length);

          //    console.log( data.SeriesName);
          if (this.userwer.indexOf(data.SeriesId) == -1) {
            this.userwer.unshift(data.SeriesId);
            this.usearr.unshift({
              fid: data.FactId,
              sid: data.SeriesId,
              sname: data.SeriesName,
              data: data,
            });
          } else {
            let j = this.userwer.indexOf(data.SeriesId);
            console.log(j);
            this.userwer.splice(j, 1);
            this.usearr.splice(j, 1);

            this.usearr.unshift({
              fid: data.FactId,
              sid: data.SeriesId,
              sname: data.SeriesName,
              data: data,
            });

            this.userwer.unshift(data.SeriesId);
          }

          //限制
          //  if(this.usearr.length<10){
          //    this.usearr=this.usearr
          //    this.userwer=this.userwer
          //  }else{
          //    this.usearr=this.usearr.slice(0,10)
          //      this.userwer=this.userwer.slice(0,10)

          //  }
          console.log(this.usearr);
          console.log(this.userwer);
          let value = JSON.stringify(this.usearr);
          let value2 = JSON.stringify(this.userwer);
          var exdate = new Date();
          exdate.setDate(exdate.getDate() + 30);
          document.cookie =
            "userarr" +
            "=" +
            decodeURIComponent(value) +
            ";expires=" +
            exdate.toGMTString();
          document.cookie =
            "userwer" +
            "=" +
            decodeURIComponent(value2) +
            ";expires=" +
            exdate.toGMTString();
          // console.log(JSON.parse(this.getCookie('userarr')));
          this.$store.commit("s", s); /* 把品类名存入vuex */
          this.$store.commit(
            "dusname",
            data.SeriesName.substring(index + 1, data.SeriesName.length)
          ); /* 把品类名存入vuex */
          let def = [];
          def = data.defaultSelected.split("-").map((x) => parseInt(x));
          this.$store.commit("defaultselect", def); /* 把品类名存入vuex */
          // console.log(data.SeriesId);
        } else {
          this.$message({
            message: "此系列暂时没有数据哦",
            type: "warning",
            center: true,
          });
        }
      }
    },
  },
};
</script>

<style scoped lang="less">
.confactleft {
  /deep/.el-input {
    margin-bottom: 12px;
    height: 2.1875rem;
    .el-input__inner {
      height: 2.1875rem;
      line-height: 2.1875rem;
    }
    .el-input__inner:focus {
      border-color: #ff9900 !important;
    }
  }
  .scrollbar {
    min-height: 30px;
    max-height: 70vh;
    overflow-y: hidden;
    .chang {
      height: auto;
      margin-bottom: 0.625rem;
      .chang-t {
        padding: 10px 10px 4px;
        // height: 1.875rem;
        vertical-align: bottom;
        font-size: 1rem;
        font-weight: 700;
        color: #333;
        border-bottom: 2px solid #efefef;
      }
      .chang-c {
        padding: 5px 10px;
        cursor: pointer;
        display: flex;
        span {
          line-height: 1.875rem;
          text-overflow: ellipsis; /*超出部分以点号代替*/
          white-space: nowrap; /*强制span不换行*/
          overflow: hidden; /*超出宽度部分隐藏*/
        }
      }
      .chang-c:hover {
        color: #ff9900;
        background-color: #f5f7fa;
      }
    }
    .data {
      height: auto;
      .data-t {
        padding: 10px 10px 4px;
        // height: 1.875rem;
        font-size: 1rem;
        font-weight: 700;
        color: #333;
        border-bottom: 1px solid #eee;
      }
      .data-c {
        padding: 5px 10px;
        cursor: pointer;
        text-overflow: ellipsis; /*超出部分以点号代替*/
        white-space: nowrap; /*强制span不换行*/
        overflow: hidden; /*超出宽度部分隐藏*/
      }
      .factactive {
        color: #ff9900;
        background-color: #f5f7fa;
      }
      .data-c::before {
        content: "●";
        margin-right: 5px;
        color: #ff9900;
        opacity: 0.5;
      }
      .data-c:hover {
        color: #ff9900;
        background-color: #f5f7fa;
      }
    }
    .search {
      height: auto;
      .search-t {
        padding: 5px 10px;
        cursor: pointer;
        color: #333;
      }
      .search-t:hover {
        color: #ff9900;
        background-color: #f5f7fa;
      }
    }
    /deep/.el-tree {
      .el-tree-node {
        .el-tree-node__children {
          .el-tree-node__content {
            .custom-tree-node {
              text-overflow: ellipsis; /*超出部分以点号代替*/
              white-space: nowrap; /*强制span不换行*/
              overflow: hidden; /*超出宽度部分隐藏*/
            }
            .custom-tree-node:hover {
              color: #ff9900;
            }
          }
          .is-focusable {
            .el-tree-node__children {
              .el-tree-node__content {
                .custom-tree-node {
                  text-overflow: ellipsis; /*超出部分以点号代替*/
                  white-space: nowrap; /*强制span不换行*/
                  overflow: hidden; /*超出宽度部分隐藏*/
                }
                .custom-tree-node:hover {
                  color: #ff9900;
                }
              }
            }
            .is-current {
              .el-tree-node__content {
                .custom-tree-node {
                  color: #ff9900;
                }
              }
            }
          }
        }
      }
    }
  }
  /* 设置滚动条样式 */
  .scrollbar::-webkit-scrollbar {
    width: 4px;
    height: 4px;
  }
  .scrollbar::-webkit-scrollbar-thumb {
    background: #eee;
    border-radius: 2px;
  }
  .scrollbar::-webkit-scrollbar-thumb:hover {
    background: #ccc;
  }
  .scrollbar::-webkit-scrollbar-corner {
    background: #f6f6f6;
  }
  .scrollbar:hover {
    overflow-y: auto;
  }
}
.confact {
  display: flex;
  .use {
    width: 40%;
    padding: 10px;
    max-height: 65vh;
    overflow-y: auto;
  }
  .useleft {
    width: 100%;
  }

  /deep/.el-input {
    margin-bottom: 12px;
    height: 2.1875rem;
    .el-input__inner {
      height: 2.1875rem;
      line-height: 2.1875rem;
    }
    .el-input__inner:focus {
      border-color: #ff9900 !important;
    }
  }
  .scrollbar {
    min-height: 30px;
    max-height: 65vh;
    overflow-y: hidden;
    .chang {
      height: auto;
      margin-bottom: 0.625rem;
      .chang-t {
        padding: 10px 10px 4px;
        // height: 1.875rem;
        vertical-align: bottom;
        font-size: 1rem;
        font-weight: 700;
        color: #333;
        border-bottom: 2px solid #efefef;
      }
      .chang-c {
        padding: 5px 10px;
        cursor: pointer;
        display: flex;
        span {
          line-height: 1.875rem;
          text-overflow: ellipsis; /*超出部分以点号代替*/
          white-space: nowrap; /*强制span不换行*/
          overflow: hidden; /*超出宽度部分隐藏*/
        }
      }
      .chang-c:hover {
        color: #ff9900;
        background-color: #f5f7fa;
      }
    }
    .data {
      height: auto;
      .data-t {
        padding: 10px 10px 4px;
        // height: 1.875rem;
        font-size: 1rem;
        font-weight: 700;
        color: #333;
        border-bottom: 1px solid #eee;
      }
      .data-c {
        padding: 5px 10px;
        cursor: pointer;
        text-overflow: ellipsis; /*超出部分以点号代替*/
        white-space: nowrap; /*强制span不换行*/
        overflow: hidden; /*超出宽度部分隐藏*/
      }
      .factactive {
        color: #ff9900;
        background-color: #f5f7fa;
      }
      .data-c::before {
        content: "●";
        margin-right: 5px;
        color: #ff9900;
        opacity: 0.5;
      }
      .data-c:hover {
        color: #ff9900;
        background-color: #f5f7fa;
      }
    }
    .search {
      height: auto;
      .search-t {
        padding: 5px 10px;
        cursor: pointer;
        color: #333;
      }
      .search-t:hover {
        color: #ff9900;
        background-color: #f5f7fa;
      }
    }
    /deep/.el-tree {
      .el-tree-node {
        .el-tree-node__children {
          .el-tree-node__content {
            .custom-tree-node {
              text-overflow: ellipsis; /*超出部分以点号代替*/
              white-space: nowrap; /*强制span不换行*/
              overflow: hidden; /*超出宽度部分隐藏*/
            }
            .custom-tree-node:hover {
              color: #ff9900;
            }
          }
          .is-focusable {
            .el-tree-node__children {
              .el-tree-node__content {
                .custom-tree-node {
                  text-overflow: ellipsis; /*超出部分以点号代替*/
                  white-space: nowrap; /*强制span不换行*/
                  overflow: hidden; /*超出宽度部分隐藏*/
                }
                .custom-tree-node:hover {
                  color: #ff9900;
                }
              }
            }
            .is-current {
              .el-tree-node__content {
                .custom-tree-node {
                  color: #ff9900;
                }
              }
            }
          }
        }
      }
    }
  }
  /* 设置滚动条样式 */
  .scrollbar::-webkit-scrollbar {
    width: 4px;
    height: 4px;
  }
  .scrollbar::-webkit-scrollbar-thumb {
    background: #eee;
    border-radius: 2px;
  }
  .scrollbar::-webkit-scrollbar-thumb:hover {
    background: #ccc;
  }
  .scrollbar::-webkit-scrollbar-corner {
    background: #f6f6f6;
  }
  .scrollbar:hover {
    overflow-y: auto;
  }
}
</style>
<style lang="less">
.search-popper {
  border-radius: 0 !important;
  box-sizing: border-box;
}
</style>

<style scoped lang="less">
@import "../assets/less/brand";
</style>
